import { defineMessages } from 'react-intl';

const sharedTranslations = defineMessages({
    ng_generic_contacts: {
        id: 'ng_generic_contacts',
        defaultMessage: '{0, plural, one {1 Contact} other {# Contacts}}'
    },
    ng_generic_groups: {
        id: 'ng_generic_groups',
        defaultMessage: '{0, plural, one {1 Group} other {# Groups}}'
    },
    ng_generic_schedules: {
        id: 'ng_generic_schedules',
        defaultMessage: '{0, plural, one {1 Schedule} other {# Schedules}}'
    },
    ng_generic_topics: {
        id: 'ng_generic_topics',
        defaultMessage: '{0, plural, one {1 Topic} other {# Topics}}'
    },
    ng_generic_map_contacts: {
        id: 'ng_generic_map_contacts',
        defaultMessage: 'Map ({0, plural, one {1 Contact} other {# Contacts}})'
    },
    ng_generic_recipients: {
        id: 'ng_generic_recipients',
        defaultMessage: '{0, plural, one {1 Recipient} other {# Recipients}}'
    },
    ng_generic_excluded: {
        id: 'ng_generic_excluded',
        defaultMessage: '{0} Excluded'
    },
    ng_generic_noResultsDescription: {
        id: 'ng_generic_noResultsDescription',
        defaultMessage: "Try adjusting your search or filter to find what you're looking for."
    },
    ng_generic_deleteAllMessage: {
        id: 'ng_generic_deleteAllMessage',
        defaultMessage: 'Are you sure you want to delete all {1}?'
    },
    ng_generic_deleteLessThen500Message: {
        id: 'ng_generic_deleteLessThen500Message',
        defaultMessage: 'Are you sure you want to delete "{0}"?'
    },
    ng_generic_areYouSureYouWantToDelete: {
        id: 'ng_generic_deleteSingleMessage',
        defaultMessage: 'Are you sure you want to delete:'
    },
    ng_generic_deleteMoreThen500Message: {
        id: 'ng_generic_deleteMoreThen500Message',
        defaultMessage: 'Are you sure you want to delete {2} {1} ?'
    },
    ng_generic_delNoAccessMsg: {
        id: 'ng_generic_delNoAccessMsg',
        defaultMessage: "You don't have access to delete the following {1}:"
    },
    ng_generic_noResultsTitle: {
        id: 'ng_generic_noResultsTitle',
        defaultMessage: 'No Results Found'
    },
    ng_generic_duplicate: {
        id: 'ng_generic_duplicate',
        defaultMessage: 'Duplicate'
    },
    ng_generic_delete: {
        id: 'ui.button.delete',
        defaultMessage: 'Delete'
    },
    ng_generic_type: {
        id: 'type',
        defaultMessage: 'Type'
    },
    ng_generic_displayName: {
        id: 'displayName',
        defaultMessage: 'Display name'
    },
    ng_generic_dateModify: {
        id: 'dateModify',
        defaultMessage: 'Date Modify'
    },
    ng_generic_assign: {
        id: 'assign',
        defaultMessage: 'Assign'
    },
    ng_generic_reassign: {
        id: 'reassign',
        defaultMessage: 'Reassign'
    },
    ng_generic_username: {
        id: 'ng_signInForm.username',
        defaultMessage: 'Username'
    },
    ng_generic_usernamePlaceholder: {
        id: 'ng_generic_usernamePlaceholder',
        defaultMessage: 'Enter username'
    },
    ng_generic_emailPlaceholder: {
        id: 'ng_generic_emailPlaceholder',
        defaultMessage: 'Enter email'
    },
    ng_generic_email: {
        id: 'ng_generic_email',
        defaultMessage: 'Email'
    },
    ng_generic_customerCommunity: {
        id: 'ng_generic_customerCommunity',
        defaultMessage: 'Customer Community'
    },
    ng_generic_password: {
        id: 'ng_signInForm.password',
        defaultMessage: 'Password'
    },
    ng_generic_passwordPlaceholder: {
        id: 'ng_generic_passwordPlaceholder',
        defaultMessage: 'Enter password'
    },
    ng_generic_languages: {
        id: 'ng_languages',
        defaultMessage: 'Languages'
    },
    ng_generic_add: {
        id: 'ng_add',
        defaultMessage: 'Add'
    },
    ng_generic_cancel: {
        id: 'ui.button.cancel',
        defaultMessage: 'Cancel'
    },
    ng_generic_back: {
        id: 'ui.button.back',
        defaultMessage: 'Back'
    },
    ng_generic_filters: {
        id: 'ng_Filters',
        defaultMessage: 'Filters'
    },
    ng_generic_more: {
        id: 'ng_generic_more',
        defaultMessage: 'more'
    },
    ng_generic_showMore: {
        id: 'ng_generic_showMore',
        defaultMessage: 'Show more'
    },
    ng_generic_close: {
        id: 'ui.page.notification.compose.section.messageAndResponseOptions.characterCount.modal.close',
        defaultMessage: 'Close'
    },
    ng_underConstruction: {
        id: 'ng_underConstruction',
        defaultMessage: 'Under Construction'
    },
    ng_optionSelected: {
        id: 'ng_optionSelected',
        defaultMessage: '1 option selected'
    },
    ng_optionsSelected: {
        id: 'ng_optionsSelected',
        defaultMessage: '{count} options selected'
    },
    ng_generic_selectAllPages: {
        id: 'ng_selectAllPages',
        defaultMessage: 'Select All Pages'
    },
    ng_generic_selectThisPage: {
        id: 'ng_selectThisPage',
        defaultMessage: 'Select This Page'
    },
    ng_generic_selectNone: {
        id: 'ng_selectNone',
        defaultMessage: 'Select None'
    },
    ng_generic_selectAll: {
        id: 'ng_selectAll',
        defaultMessage: 'Select All'
    },
    ng_generic_deselectAll: {
        id: 'ng_generic_deselectAll',
        defaultMessage: 'Deselect All'
    },
    ng_generic_comingSoon: {
        id: 'ng_comingSoon',
        defaultMessage: 'Coming soon'
    },
    ng_generic_checkoutComingSoon: {
        id: 'ng_checkingComingSoon',
        defaultMessage: 'Check out what’s coming soon!'
    },
    ng_underConstructionMsg: {
        id: 'ng_underConstructionMsg',
        defaultMessage: 'We are working on bringing you new and exciting features.'
    },
    ng_shared_overview: {
        id: 'ng_groupCreate_Overview',
        defaultMessage: 'Overview'
    },
    ng_shared_sms: {
        id: 'ng_sms',
        defaultMessage: 'SMS'
    },
    ng_shared_voice: {
        id: 'ng_Voice',
        defaultMessage: 'Voice'
    },
    ng_shared_responseOptions: {
        id: 'ng_responseOptions',
        defaultMessage: 'Response Options'
    },
    ng_shared_priority: {
        id: 'ng_priority',
        defaultMessage: 'Priority'
    },
    ng_shared_locations: {
        id: 'locations',
        defaultMessage: 'Locations'
    },
    ng_shared_locationType: {
        id: 'ng_shared_locationType',
        defaultMessage: 'Location Type'
    },
    ng_shared_groups: {
        id: 'ng_shared_groups',
        defaultMessage: 'Groups'
    },
    ng_shared_categories: {
        id: 'ng_shared_categories',
        defaultMessage: 'Categories'
    },
    ng_shared_topics: {
        id: 'ui.page.notification.compose.section.topics',
        defaultMessage: 'Topics'
    },
    ng_shared_weatherAndEvents: {
        id: 'ng_weatherAndEvents',
        defaultMessage: 'Weather & Events'
    },
    ng_shared_subscriptions: {
        id: 'subscriptions',
        defaultMessage: 'Subscriptions'
    },
    ng_shared_profiles: {
        id: 'profiles',
        defaultMessage: 'Profiles'
    },
    ng_shared_active: {
        id: 'ng_shared_active',
        defaultMessage: 'Active'
    },
    ng_generic_all: {
        id: 'ng_generic_all',
        defaultMessage: 'All'
    },
    ng_shared_all_var: {
        id: 'ng_shared_all_var',
        defaultMessage: '{0}All'
    },
    ng_shared_email_var: {
        id: 'ng_shared_email_var',
        defaultMessage: '{0}Email'
    },
    ng_shared_sms_var: {
        id: 'ng_shared_sms_var',
        defaultMessage: '{0}SMS'
    },
    ng_shared_voice_var: {
        id: 'ng_shared_voice_var',
        defaultMessage: '{0}Voice'
    },
    ng_shared_voice_mail_var: {
        id: 'ng_shared_voice_mail_var',
        defaultMessage: '{0}Voicemail'
    },
    ng_shared_desktop_alert_var: {
        id: 'ng_shared_desktop_alert_var',
        defaultMessage: '{0}Desktop Alerts'
    },
    ng_shared_tty_var: {
        id: 'ng_shared_tty_var',
        defaultMessage: '{0}TTY Phone'
    },
    ng_shared_alertus_var: {
        id: 'ng_shared_alertus_var',
        defaultMessage: '{0}Alertus'
    },
    ng_shared_twitter_var: {
        id: 'ng_shared_twitter_var',
        defaultMessage: '{0}Twitter'
    },
    ng_shared_slack_var: {
        id: 'ng_shared_slack_var',
        defaultMessage: '{0}Slack'
    },
    ng_shared_msteams_var: {
        id: 'ng_shared_msteams_var',
        defaultMessage: '{0}Microsoft Teams'
    },
    ng_shared_fax_var: {
        id: 'ng_shared_fax_var',
        defaultMessage: '{0}Fax'
    },
    ng_shared_pager_var: {
        id: 'ng_shared_pager_var',
        defaultMessage: '{0}Pager One Way'
    },
    ng_shared_pager_two_way_var: {
        id: 'ng_shared_pager_two_way_var',
        defaultMessage: '{0}Pager Two Way'
    },
    ng_shared_recording_var: {
        id: 'ng_shared_recording_var',
        defaultMessage: '{0}Recording'
    },
    ng_generic_one: {
        id: 'ng_generic_one',
        defaultMessage: 'One'
    },
    ng_generic_addBulk: {
        id: 'ng_contact.advancedSearch',
        defaultMessage: 'Bulk Add'
    },
    ng_generic_shiftTierNumber: {
        id: 'ng_schedules_shiftTierNumber',
        defaultMessage: 'Tier {0}'
    },
    ng_generic_addShiftTier: {
        id: 'ng_schedules_addShiftTier',
        defaultMessage: 'Add Tier'
    },
    ng_generic_question: {
        id: 'ng_generic_question',
        defaultMessage: 'Question'
    },
    ng_generic_phoneNumber: {
        id: 'ng_generic_phoneNumber',
        defaultMessage: 'Phone Number'
    },
    ng_alerts_noDurationError: {
        id: 'ng_alerts_tierNoDurationError',
        defaultMessage: 'Please enter a value for the duration.'
    },
    ng_generic_alert: {
        id: 'ng_rpt_alert',
        defaultMessage: 'Alert'
    },
    ng_generic_exit: {
        id: 'ng_generic_exit',
        defaultMessage: 'Exit'
    },
    ng_generic_continueEditing: {
        id: 'ng_generic_continueEditing',
        defaultMessage: 'Continue Editing'
    },
    ng_generic_countryCode: {
        id: 'ng_contact.countryCode.label',
        defaultMessage: 'Country Code'
    },
    ng_generic_enterPhoneNumber: {
        id: 'ng_contact.devices.defaultValue.placeholder',
        defaultMessage: 'Enter phone number'
    },
    ng_shared_notificationsIcon: {
        id: 'ng_shared_notificationsIcon',
        defaultMessage: 'Notifications Icon'
    },
    ng_shared_searchIcon: {
        id: 'ng_shared_searchIcon',
        defaultMessage: 'Search Icon'
    },
    ng_shared_collapseBtn: {
        id: 'ng_shared_collapseBtn',
        defaultMessage: 'Collapse Button'
    },
    ng_shared_profileMenu: {
        id: 'ng_shared_profileMenu',
        defaultMessage: 'Profile Menu'
    },
    ng_shared_viewDetails: {
        id: 'ng_shared_viewDetails',
        defaultMessage: 'View Details'
    },
    ng_shared_images: {
        id: 'ng_shared_images',
        defaultMessage: 'Images'
    },
    ng_shared_selectRow: {
        id: 'ng_shared_selectRow',
        defaultMessage: 'Select Row'
    },
    ng_shared_about: {
        id: 'ng_shared_about',
        defaultMessage: 'About'
    },
    ng_shared_uploadFile: {
        id: 'ng_contacts_importContacts_uploadFile',
        defaultMessage: 'Upload File'
    },
    ng_shared_maxFileSize: {
        id: 'ng_shared_maxFileSize',
        defaultMessage: 'Maximum file size: {0}'
    },
    ng_shared_dropFile: {
        id: 'ng_shared_dropFile',
        defaultMessage: 'Drop your file here, or '
    },
    ng_shared_browse: {
        id: 'ng_shared_browse',
        defaultMessage: 'Browse'
    },
    ng_shared_fileSupport: {
        id: 'ng_shared_fileSupport',
        defaultMessage: 'Supports .csv and .scsv'
    },
    ng_shared_fileName: {
        id: 'ng_shared_fileName',
        defaultMessage: 'File Name'
    },
    ng_shared_uploadedBy: {
        id: 'ng_shared_uploadedBy',
        defaultMessage: 'Uploaded By'
    },
    ng_shared_history: {
        id: 'ng_contact.history',
        defaultMessage: 'History'
    },
    ng_shared_youSent: {
        id: 'ng_alerts_youSent',
        defaultMessage: 'You sent'
    },
    ng_shared_action: {
        id: 'ng_shared_action',
        defaultMessage: 'Action'
    },
    ng_shared_deleteGroups: {
        id: 'ng_groupList_deleteGroup',
        defaultMessage: 'Delete {selectedGroupsCount, plural, one {Group} other {Groups}}'
    },
    ng_shared_successfullyDeleted: {
        id: 'ng_customFields_successfully_deleted',
        defaultMessage: 'Successfully deleted {0}.'
    },
    ng_shared_failedToDelete: {
        id: 'ng_shared_failedToDelete',
        defaultMessage: 'Failed to delete {0}.'
    },
    ng_shared_deleteModalHeader: {
        id: 'ng_schedules_removeHolidayCalendar',
        defaultMessage: 'Delete {0}'
    },
    ng_shared_lockBoxSecureNoAccess: {
        id: 'ng_lockBox_secureTypeDescr',
        defaultMessage: 'Lockbox secure files can only be accessed through the mobile app.'
    },
    ng_shared_selectOrganization: {
        id: 'ng_shared_selectOrganization',
        defaultMessage: 'Select organization'
    },
    ng_shared_sendAlertConfirmation: {
        id: 'ng_shared_sendAlertConfirmation',
        defaultMessage: 'You’re about to send <b>{0}</b>'
    },
    ng_shared_showPassword: {
        id: 'ng_shared_showPassword',
        defaultMessage: 'Show password'
    },
    ng_shared_hidePassword: {
        id: 'ng_shared_hidePassword',
        defaultMessage: 'Hide password'
    },
    ng_generic_other: {
        id: 'ng_contact.filters.others',
        defaultMessage: 'Other'
    },
    ng_shared_import: {
        id: 'ng_contacts_import',
        defaultMessage: 'Import'
    },
    ng_shared_uploadToImportTitle: {
        id: 'ng_contacts_importContacts_uploadTitle',
        defaultMessage: 'Upload file to import'
    },
    ng_shared_review: {
        id: 'ng_contacts_importContacts_review',
        defaultMessage: 'Review'
    },
    ng_shared_importFileFormattingRequirements: {
        id: 'ng_contacts_importContacts_formattingRequirements',
        defaultMessage: 'Before import, make sure the file is formatted correctly.'
    },
    ng_shared_tryAgain: {
        id: 'ng_contact.tryAgain',
        defaultMessage: 'Try Again'
    },
    ng_shared_uploadingPercentage: {
        id: 'ng_contacts_importContacts_uploadingPercentage',
        defaultMessage: 'Uploading... <b>{0}</b>%'
    },
    ng_shared_cancelImportQuestion: {
        id: 'ng_contacts_importContacts_cancelImportAsk',
        defaultMessage: 'Cancel Import?'
    },
    ng_shared_cancelImportMessage: {
        id: 'ng_contacts_importContacts_cancelImportAskMessage',
        defaultMessage: 'This import has not been completed. Cancelling this import will lose all progress.'
    },
    ng_shared_customField: {
        id: 'ng_customFields_columnField',
        defaultMessage: 'Custom Field'
    },
    ng_shared_recordType: {
        id: 'ng_shared_selectRecordType',
        defaultMessage: 'Record Type'
    },
    ng_shared_selectRecordType: {
        id: 'ng_shared_selectRecordType',
        defaultMessage: 'Select Record Type'
    },
    ng_shared_override: {
        id: 'ng_shared_override',
        defaultMessage: 'Override'
    },
    ng_shared_invalidFileType: {
        id: 'ng_file_upload_type_error',
        defaultMessage: 'File type is invalid'
    },
    ng_shared_invalidOptions: {
        id: 'ng_shared_invalidOptions',
        defaultMessage: 'There should be at least one option'
    },
    ng_shared_invalidDefaultOption: {
        id: 'ng_shared_invalidDefaultOption',
        defaultMessage: 'Choose default option'
    },
    ng_shared_options_limit: {
        id: 'ng_shared_options_limit',
        defaultMessage: 'Options limit'
    },
    ng_shared_places: {
        id: 'ng_shared_places',
        defaultMessage: 'Places'
    },
    ng_shared_addOneOption: {
        id: 'ng_shared_addOneOption',
        defaultMessage: 'Please add at least 1 option'
    },
    ng_shared_selectDefaultOption: {
        id: 'ng_shared_addOneOption',
        defaultMessage: 'Please select default option'
    },
    ng_shared_option_must_be_unique: {
        id: 'ng_shared_option_must_be_unique',
        defaultMessage: 'Option must be unique.'
    },
    ng_shared_type_none: {
        id: 'ng_shared_type_none',
        defaultMessage: 'None'
    }
});

export default sharedTranslations;
